import axios from 'axios';

export const containerThermographerApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/container-thermographer`,
    headers: {
        'Content-Type': 'application/json'
    }
})